/** @format */

import {Link} from 'react-router-dom';
import {If} from 'frontier-utilities';
import React from 'react';

export const IdColumn = props => {
    const {order} = props;

    const viewOrderPath = `/account/orders/view/${order.id}`;

    return (
        <div className="orders-list-table-active-31cs__column--id d-flex align-items-center justify-content-end">
            <Link style={{fontSize: '16px'}} to={viewOrderPath}>
                {order.label}
            </Link>
            <If condition={!!order.po_number}>
                <b className="m-0 p-0 color-structure-darker">PO: {order.po_number}</b>
            </If>
        </div>
    );
};
